import { Component, EventEmitter, Input, Output } from '@angular/core';
import { StudentOverviewComponent } from 'src/app/private/components/temp-student-profile/student-overview/student-overview.component';
import { SharedModule } from 'src/app/private/shared/shared.module';
import { UpdateStudentDocumentComponent } from "../update-student-document/update-student-document.component";

@Component({
  selector: 'app-student-temp-profile-middle-screen',
  imports: [SharedModule, StudentOverviewComponent, UpdateStudentDocumentComponent],
  templateUrl: './student-temp-profile-middle-screen.component.html',
  styleUrl: './student-temp-profile-middle-screen.component.scss'
})
export class StudentTempProfileMiddleScreenComponent {
 @Input() studentDetails: any = {};
 @Input() editLeadData: any = {};
  @Input() selectedTabIdx: any = 0;
  @Output() tabChanged = new EventEmitter<number>();
  @Input() student_profile_stage: string = '';
  @Input() fullUser: any[] = [];
  @Input() allLeadFeilds: any[] = [];


  @Input() allCourses: any[] = [];
  @Input() batchList: any[] = [];
  @Input() academicYearList: any[] = [];
  @Input() feeCategoryList: any[] = [];
  @Input() departmentList: any[] = [];

  @Input() hostelCategoryList: any[] = [];
  @Input() scholarshipTypeList: any[] = [];
  @Input() transportRouteList: any[] = [];

  @Input() users : any[] = [];

  tabs = [
    { label: 'Overview', key: 'overview' },
    { label: 'Attendance', key: 'attendance' },
    { label: 'Exams', key: 'exams' },
    { label: 'Time Table', key: 'timetable' },
    { label: 'Fees', key: 'fees' },
    { label: 'Library Details', key: 'library' },
    { label: 'Documents', key: 'documents' },
    { label: 'Hostel', key: 'hostel' },
    { label: 'Transport', key: 'transport' }
  ];

  selectTab(index: any) {
    console.log('Selected Tab Index:', index);
    this.selectedTabIdx = index;
    this.tabChanged.emit(index);
  }

  handleUpdate(updatedDetails: any) {
    console.log('Updated Student Details:', updatedDetails);
  }
}
